module.exports = __webpack_public_path__ + "static/phone_image_mobile-4bf91b4b48833eca0ddb2e9b2aa34730.png";